<template>
    <div class="profile flex flex-center flex-align">
        <img v-if="user && user.profile_image_url" :src="user.profile_image_url" />
        <div class="placeholder" v-else></div>
    </div>
</template>

<script>
    export default {
        name: 'Profile',
        props: {
            user: Object
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .profile
    {
        width: 32px;
        height: 32px;
        display: block;
    }

    .placeholder
    {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: url('~@/assets/icons/white/account.svg') center center no-repeat;
        background-size: 30px auto;
    }

    [theme="light"] .placeholder
    {
        background-image: url('~@/assets/icons/black/account.svg');
    }
</style>
